import { withHydrate } from '@relay/react/hooks';
import withRedux from '@helpers/withRedux';
import { withMotion } from '@hoc/withMotion';
import FooterBottom from '@stories/Components/Footer/FooterBottom/FooterBottom';
import FooterDownloads from '@stories/Components/Footer/FooterDownloads/FooterDownloads';
import FooterMenu from '@stories/Components/Footer/FooterMenu/FooterMenu';
import React from 'react';
import s from './Footer.styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Footer = ({
  menuItems,
  downloadItems,
  socialItems,
  bottomItems,
  availableCultures,
  translations,
  pageContext: {
    documentCulture
  }
}) => {
  return /*#__PURE__*/_jsx(s.Wrapper, {
    "data-footer": "site-footer",
    children: /*#__PURE__*/_jsxs(s.Contents, {
      children: [/*#__PURE__*/_jsx(FooterMenu, {
        items: menuItems
      }), /*#__PURE__*/_jsx(FooterDownloads, {
        items: downloadItems,
        translations: translations
      }), /*#__PURE__*/_jsx(FooterBottom, {
        items: bottomItems,
        socialItems: socialItems,
        translations: translations,
        documentCulture: documentCulture,
        cultures: availableCultures
      })]
    })
  });
};
export default withHydrate(withMotion(withRedux(Footer)), 'Footer', 'hybrid');
